export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 15.5L8.5 15.5L8.5 8L15.5 8L15.5 3L3.5 3L3.5 15.5Z"
      fill="#D8D8D8"
    />
    <path
      d="M2 5C2.00006 3.3432 3.34318 2 5 2L13.7891 2C15.4459 2 16.789 3.34319 16.7891 5L16.7891 7.21094L19 7.21094C20.6568 7.21097 22 8.5541 22 10.2109L22 19C22 20.6568 20.6568 22 19 22L10.2109 22C8.55409 22 7.21094 20.6569 7.21094 19L7.21094 16.7891L5 16.7891C3.34315 16.7891 2 15.4459 2 13.7891L2 5ZM9.21094 19C9.21094 19.5523 9.65865 20 10.2109 20L19 20C19.5523 20 20 19.5523 20 19L20 10.2109C20 9.65867 19.5523 9.21097 19 9.21094L10.2109 9.21094C9.65865 9.21094 9.21094 9.65865 9.21094 10.2109L9.21094 19ZM4 13.7891C4 14.3413 4.44772 14.7891 5 14.7891L7.21094 14.7891L7.21094 10.2109C7.21094 8.55408 8.55408 7.21094 10.2109 7.21094L14.7891 7.21094L14.7891 5C14.789 4.44777 14.3413 4 13.7891 4L5 4C4.44775 4 4.00006 4.44777 4 5L4 13.7891Z"
      fill="currentColor"
    />
  </svg>
);
